import { CloseIcon } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon/index';
import { getLocationIcon } from '@components/ui/search/SearchLocation/utils/getLocationIcon';

import {
  ClearSearchButton,
  ListItem,
  ItemText,
  ListItemContent,
} from './styled';
import { BookerSearchViewModel } from './BookerSearchViewModel';

const handleStrongLetter = (input: string, text: string) => {
  const inputLength = input.length;
  let boldText = '';
  let part1 = '';
  let part2 = '';
  let isBoldText = false;
  for (let i = 0; i <= text.length - input.length; i++) {
    if (
      text.slice(i, i + inputLength).toLocaleUpperCase('tr-TR') ===
      input.toLocaleUpperCase('tr-TR')
    ) {
      part1 = text.slice(0, i);
      boldText = text.slice(i, i + inputLength);
      part2 = text.slice(i + inputLength, text.length);
      isBoldText = true;
      break;
    }
  }
  if (isBoldText != false) {
    return (
      <span>
        {part1}
        <strong>{boldText}</strong>
        {part2}
      </span>
    );
  } else {
    return <span>{text}</span>;
  }
};

interface BookerResultListProps {
  item: BookerSearchViewModel;
  onChange: (item: BookerSearchViewModel) => void;
  callBack?: (item: BookerSearchViewModel) => void;
  showRemoveButton?: boolean;
  onRemoveItem?: (item: BookerSearchViewModel) => void;
  inputLocation?: string;
}

export const BookerResultList = ({
  item,
  onChange,
  callBack,
  onRemoveItem,
  showRemoveButton = false,
  inputLocation = '',
}: BookerResultListProps) => {
  const handleItemClick = () => {
    onChange(item);
    callBack && callBack(item);
  };
  return (
    <>
      {item?.text ? (
        <ListItem>
          <ListItemContent onClick={handleItemClick}>
            <CustomIcon
              paletteColor='brownishGrey'
              fontSize={24}
              icon={getLocationIcon(item?.type || '')}
            />
            <ItemText>
              {inputLocation
                ? handleStrongLetter(inputLocation, item.text)
                : item.text}
            </ItemText>
          </ListItemContent>
          {showRemoveButton ? (
            <ClearSearchButton
              onClick={onRemoveItem ? () => onRemoveItem(item) : undefined}
            >
              <em>
                <CustomIcon
                  paletteColor='brownishGrey'
                  fontSize={16}
                  icon={CloseIcon}
                />
              </em>
            </ClearSearchButton>
          ) : null}
        </ListItem>
      ) : null}
    </>
  );
};
